import React, { useState, useEffect, useRef } from 'react'
import { AreaPicker, Header } from '@/components'
import { history } from '@/util'
import { Form, Input, Button, TextArea, Switch } from 'antd-mobile'
import queryString from 'query-string'
import { useTranslation } from 'react-i18next';
import { LocalKeyMap } from '@/local';

import './index.scss'

const MyIndex = props => {
  const { t } = useTranslation();

  return (
    <div className="login-container">
      <Header
        //   backIcon={
        //   <>
        //     <img className="headerIcon"
        //         src={backIcon} />
        //   </>
        // }
          extraclassName="address-header"
          immersed
          isFixed
          isPlaceholder
          isPullShowWhiteHeader={false}
          mode="light"
        // ref={headerRef}
          // style={headerStyle}
          title={t(LocalKeyMap['myIndex.title'])}
      />
      {/* 登录信息 */}
      <div className="login-box">
        <div className="login-info">
          <div className="user-name">9826168990@163.com</div>
          <div className="user-id">ID: 12345667</div>
        </div>
        <div className="login-btn">
          {t(LocalKeyMap['myIndex.logIn'])}
        </div>
      </div>
      {/* 我的积分和卡包入口 */}
      <div className="my-assets">
        <div className="my-points">
          <i className="assets-icon icon-points"></i>
          <div className="assets-info">
            <div className="num">
              <div className="text">0pt</div>
              <div className="more"></div>
            </div>
            <div className="tip"></div>
          </div>
        </div>
        <div className="my-cards">
          <i className="assets-icon icon-cards"></i>
          <div className="assets-info">
            <div className="num">
              <div className="text">{t(LocalKeyMap['myIndex.myCardBag'])}</div>
              <div className="more"></div>
            </div>
            <div className="tip"></div>
          </div>
        </div>
      </div>
      {/* 订单信息 */}
      <div className="orders-info">
        <div className="title">{t(LocalKeyMap['myIndex.orderTip'])}</div>
        <div className="body">
          <div className="list">
            <ul>
              <li>
                <i className="icon icon-order"></i>
                <i className="text">{t(LocalKeyMap['myIndex.myOrder'])}</i>
              </li>
              <li>
                <i className="icon icon-deliver"></i>
                <i className="text">{t(LocalKeyMap['myIndex.shippingOrder'])}</i>
              </li>
              <li>
                <i className="icon icon-finished"></i>
                <i className="text">{t(LocalKeyMap['myIndex.completedOrder'])}</i>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* 我的其他列表 */}
      <div className="setting-list">
        <div className="list">
          <li>
            <div className="item-l">
              <i className="icon icon-address"></i>
              <span className="text">{t(LocalKeyMap['myIndex.address'])}</span>
            </div>
            <div className="item-r">
              <i className="icon-more"></i>
            </div>
          </li>
          {/* <li>
            <div className="item-l">
              <i className="icon icon-pay"></i>
              <span className="text">{t(LocalKeyMap['myIndex.payment'])}</span>
            </div>
            <div className="item-r">
              <i className="icon-more"></i>
            </div>
          </li> */}
          <li>
            <div className="item-l">
              <i className="icon icon-regions"></i>
              <span className="text">{t(LocalKeyMap['myIndex.switchRegions'])}</span>
            </div>
            <div className="item-r">
              <i className="icon-country"></i>
              <i className="icon-more"></i>
            </div>
          </li>
          <li>
            <div className="item-l">
              <i className="icon icon-language"></i>
              <span className="text">{t(LocalKeyMap['myIndex.switchLanguage'])}</span>
            </div>
            <div className="item-r">
              <i className="icon-language"></i>
              <i className="icon-more"></i>
            </div>
          </li>
          <li>
            <div className="item-l">
              <i className="icon icon-service"></i>
              <span className="text">{t(LocalKeyMap['myIndex.customerService'])}</span>
            </div>
            <div className="item-r">
              <i className="icon-more"></i>
            </div>
          </li>
          <li>
            <div className="item-l">
              <i className="icon icon-privacy"></i>
              <span className="text">{t(LocalKeyMap['login.privacyPolicy'])}</span>
            </div>
            <div className="item-r">
              <i className="icon-more"></i>
            </div>
          </li>
          <li>
            <div className="item-l">
              <i className="icon icon-agreement"></i>
              <span className="text">{t(LocalKeyMap['login.termsService'])}</span>
            </div>
            <div className="item-r">
              <i className="icon-more"></i>
            </div>
          </li>
          <li>
            <div className="item-l">
              <i className="icon icon-logout"></i>
              <span className="text">{t(LocalKeyMap['myIndex.logOut'])}</span>
            </div>
            <div className="item-r">
              <i className="icon-more"></i>
            </div>
          </li>
        </div>
      </div>
    </div>
  )
}

export default MyIndex
